import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Spinner } from "./Spinner.js";
import { Button } from "./buttons.js";
export function SwitchNetworkButton(props) {
    const [isSwitching, setIsSwitching] = useState(false);
    return (_jsx(Button, { ...props, gap: "xs", onClick: async () => {
            setIsSwitching(true);
            try {
                await props.switchChain();
            }
            catch { }
            setIsSwitching(false);
        }, children: isSwitching ? (_jsxs(_Fragment, { children: ["Switching", _jsx(Spinner, { size: "sm", color: "accentButtonText" })] })) : ("Switch Network") }));
}
//# sourceMappingURL=SwitchNetwork.js.map